import { eventbus } from '../utils/eventBus'

export const IolpayEvents = eventbus()
